import { TIME_UNITS } from '@/constants/date';

export const SINGLE_EVENT_RESEND_DELAY = {
  value: 1,
  unit: TIME_UNITS.second,
};
